import * as React from 'react'
import {View} from './View'
import {TestSite} from './Main/Index/Index'
// import {Main} from '../Logic/Main'

/*
function getTime() {
    var now = new Date()
    var time = now.getTime()
    time += 3600000
    return time
}

function setCookies () {
    if( Main.Instance.LoginState &&
        Main.Instance.Location &&
        Main.Instance.LoginState.Username &&
        Main.Instance.LoginState.Mail) {
            // document.cookie = 'username=' + Main.Instance.LoginState.Username
            // document.cookie = 'mail=' + Main.Instance.LoginState.Mail
            let location = Main.Instance.Location == '/index' ? '/index' : Main.Instance.Location
            document.cookie = 'location=' + location
            document.cookie = 'expires=' + getTime().toString()
        }
}
*/
export function MainView(props: React.Props<{}>): View {
    // setCookies ()
    return(<div><div id = "wrapper">{TestSite (props)}</div></div>)
}





// WEBPACK FOOTER //
// ./src/Views/Main.tsx